// import React, { useEffect, useState } from 'react';
// import { CustomInput, MarkupMainContainer } from '../../../StyledComponents/Markup';
// import { Row, Col } from 'antd';
// import { useSelector,useDispatch } from 'react-redux';
// import { getcustomercategorylist,updateCustomerCategoryMarkup } from "../../../store/Markup/markupSlice";

// export const CustomerCategory = () => {
//   const [selectedRecord, setSelectedRecord] = useState(null);
//   const [customerCategoryData, setCategory] = useState([]);
//   const { customerCategory } = useSelector((state) => state.markup);
//   const dispatch=useDispatch();

//   const handleBlur = (element) => {
//     console.log("element",element,selectedRecord)

//   };

//   return (
//     <MarkupMainContainer>
//       {
//         customerCategory && customerCategory.map((element) => (
//           <Row align="middle" gutter={[16, 16]} className="flex w-full justify-center my-2">
//             <Col xs={24} sm={8} md={6} className="text-center text-lg font-medium">
//               Category {element.category_name}
//             </Col>
//             <Col xs={24} sm={16} md={10}>
//               <CustomInput
//                 className="w-full"
//                 type="number"
//                 placeholder="Filled"
//                 value={element?.markup_percentage || 0}
//                 onChange={(e) => setSelectedRecord(element)}
//                 onBlur={()=>{handleBlur(element)}}
//               />
//             </Col>
//           </Row>
//         ))
//       }
//     </MarkupMainContainer>
//   );
// };

import React, { useEffect, useState } from "react";
import {
  CustomInput,
  MarkupMainContainer,
} from "../../../StyledComponents/Markup";
import { Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  getcustomercategorylist,
  updateCustomerCategoryMarkup,
} from "../../../store/Markup/markupSlice";
import { updatenotificationdata } from "../../../store/Common/CommonSlice";

export const CustomerCategory = () => {
  const [editableField, setEditableField] = useState(null); // store row + field
  const [updatedValues, setUpdatedValues] = useState({});
  const { customerCategory } = useSelector((state) => state.markup);
  const dispatch = useDispatch();

  useEffect(() => {
    if (customerCategory?.length) {
      const initialValues = customerCategory.reduce((acc, category) => {
        acc[category._id] = {
          markup_percentage: category.markup_percentage ?? 0,
          ocean_origin_markup: category.ocean_origin_markup ?? 0,
          ocean_destination_markup: category.ocean_destination_markup ?? 0,
          ocean_freight_markup: category.ocean_freight_markup ?? 0,
        };
        return acc;
      }, {});
      setUpdatedValues(initialValues);
    }
  }, [customerCategory]);

  const handleBlur = (categoryId, fieldName) => {
    const fieldValue = updatedValues[categoryId][fieldName];

    const payload = {
      category_id: categoryId,
      [fieldName]: Number(fieldValue),
    };

    dispatch(updateCustomerCategoryMarkup(payload))
      .then((res) => {
        dispatch(updatenotificationdata(res.payload));
        setEditableField(null);
      })
      .catch((err) => {
        dispatch(updatenotificationdata(err?.payload?.data));
      });
  };

  const handleInputChange = (categoryId, fieldName, value) => {
    setUpdatedValues((prev) => ({
      ...prev,
      [categoryId]: {
        ...prev[categoryId],
        [fieldName]: value,
      },
    }));
  };

  return (
  <MarkupMainContainer>

    <Row gutter={10} className="mb-1">
      <Col xs={24} md={4}></Col> 
      <Col xs={24} md={20}>
        <Row gutter={10}>
          <Col span={5} className="font-semibold text-center text-blue-600">
            Air Freight
          </Col>
          {/* Ocean Origin / Ocean Destionation headers hidden
          <Col span={5} className="font-semibold text-center text-blue-600">
            Ocean Origin
          </Col>
          <Col span={7} className="font-semibold text-center text-blue-600">
            Ocean Destionation
          </Col>
          */}
          <Col span={5} className="font-semibold text-center text-blue-600">
            Ocean Freight
          </Col>
        </Row>
      </Col>
    </Row>
    {/* -------------------------------------------------------- */}

    {customerCategory?.map((element) => (
      <Row key={element._id} className="flex w-full my-3" align="middle">
        
        {/* Category Name */}
        <Col xs={24} md={4} className="font-semibold text-lg">
          Category {element.category_name}
        </Col>

        <Col xs={24} md={20}>
          {/* Editable Fields (Your existing code remains same) */}
          <Row gutter={10}>
            {/* markup_percentage */}
            <Col span={5}>
              {editableField === `${element._id}_markup_percentage` ? (
                <CustomInput
                  type="number"
                  value={updatedValues[element._id]?.markup_percentage}
                  onChange={(e) =>
                    handleInputChange(
                      element._id,
                      "markup_percentage",
                      e.target.value
                    )
                  }
                  onBlur={() => handleBlur(element._id, "markup_percentage")}
                />
              ) : (
                <div
                  className="p-2 border rounded cursor-pointer"
                  onClick={() =>
                    setEditableField(`${element._id}_markup_percentage`)
                  }
                >
                  {updatedValues[element._id]?.markup_percentage}%
                </div>
              )}
            </Col>

            {/* ocean_origin_markup / ocean_destination_markup hidden
            <Col span={5}>
              {editableField === `${element._id}_ocean_origin_markup` ? (
                <CustomInput
                  type="number"
                  value={updatedValues[element._id]?.ocean_origin_markup}
                  onChange={(e) =>
                    handleInputChange(
                      element._id,
                      "ocean_origin_markup",
                      e.target.value
                    )
                  }
                  onBlur={() => handleBlur(element._id, "ocean_origin_markup")}
                />
              ) : (
                <div
                  className="p-2 border rounded cursor-pointer"
                  onClick={() =>
                    setEditableField(`${element._id}_ocean_origin_markup`)
                  }
                >
                  {updatedValues[element._id]?.ocean_origin_markup}%
                </div>
              )}
            </Col>

            <Col span={7}>
              {editableField === `${element._id}_ocean_destination_markup` ? (
                <CustomInput
                  type="number"
                  value={updatedValues[element._id]?.ocean_destination_markup}
                  onChange={(e) =>
                    handleInputChange(
                      element._id,
                      "ocean_destination_markup",
                      e.target.value
                    )
                  }
                  onBlur={() =>
                    handleBlur(element._id, "ocean_destination_markup")
                  }
                />
              ) : (
                <div
                  className="p-2 border rounded cursor-pointer"
                  onClick={() =>
                    setEditableField(`${element._id}_ocean_destination_markup`)
                  }
                >
                  {updatedValues[element._id]?.ocean_destination_markup}%
                </div>
              )}
            </Col>
            */}

            {/* ocean_freight_markup */}
            <Col span={5}>
              {editableField === `${element._id}_ocean_freight_markup` ? (
                <CustomInput
                  type="number"
                  value={updatedValues[element._id]?.ocean_freight_markup}
                  onChange={(e) =>
                    handleInputChange(
                      element._id,
                      "ocean_freight_markup",
                      e.target.value
                    )
                  }
                  onBlur={() => handleBlur(element._id, "ocean_freight_markup")}
                />
              ) : (
                <div
                  className="p-2 border rounded cursor-pointer"
                  onClick={() =>
                    setEditableField(`${element._id}_ocean_freight_markup`)
                  }
                >
                  {updatedValues[element._id]?.ocean_freight_markup}%
                </div>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    ))}
  </MarkupMainContainer>
);
};
